export default {
  data() {
    return {
      currencyOptions: {
        locale: "tr",
        currency: null,
        valueAsInteger: false,
        distractionFree: false,
        hideCurrencySymbol: true,
        hideGroupingSymbol: true,
        precision: 2,
        autoDecimalMode: false,
        valueRange: { min: 0, max: 999999999 },
        allowNegative: false,
      },
      currencyOptionsWithoutDigit: {
        locale: "tr",
        currency: null,
        valueAsInteger: true,
        distractionFree: false,
        hideCurrencySymbol: true,
        hideGroupingSymbol: true,
        precision: 0,
        autoDecimalMode: false,
        valueRange: { min: 0, max: 999999999 },
        allowNegative: false,
      },
    };
  },
  computed: {
    toCurrency() {
      return (value, currency = "TRY") => {
        if (typeof value !== "number") {
          return value;
        }
        const formatter = new Intl.NumberFormat("tr", {
          style: "currency",
          currency,
        });
        return formatter.format(value);
      };
    },
    toCurrencyWithParam() {
      return (value) => {
        if (typeof value !== "number") {
          return value;
        }

        const formatter = new Intl.NumberFormat("tr", {
          style: "currency",
          currency: this.selectedCurrencyType || "TRY", // Dinamik para birimi
        });

        return formatter.format(value);
      };
    },
    formatCurrencyForInput() {
      return (number) => {
        return number.toLocaleString("tr", { minimumFractionDigits: 2 });
      };
    },
    exchangeRatePdfFields() {
      // Uluslararası bilette makbuz PDF'inde "1 EUR = X TRY" olarak basılan kur; yurt içinde alan gönderilmez.
      return (price) => {
        if (!price || !price.exchangeRate || !price.originalCurrency || price.originalCurrency === "TRY") return {};
        return {
          exchangeRate: price.exchangeRate.toLocaleString("tr", { minimumFractionDigits: 2, maximumFractionDigits: 4 }),
          originalCurrency: price.originalCurrency,
        };
      };
    },
    convertStringToNumber() {
      return (val) => {
        if (typeof val === "number" || !val) return val;
        return Number(val.replaceAll(".", "").replaceAll(",", "."));
      };
    },
    formatCurrencyForTooltipWithoutDigit() {
      return (value, currency = "TRY") => {
        if (typeof value !== "number") {
          return value;
        }
        const formatter = new Intl.NumberFormat("tr-TR", {
          style: "currency",
          currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
        return formatter.format(value);
      };
    },
    convertStringToNumberForInternationTicket() {
      return (val) => {
        if (typeof val === "number" || !val) return val;

        // Hem "," hem "." varsa: büyük ihtimalle Avrupa formatı: "1.234,56"
        if (val.includes(",") && val.includes(".")) {
          return Number(val.replaceAll(".", "").replace(",", "."));
        }

        // Sadece "." varsa ve bu binlik ayırıcıysa: "5.000"
        if (!val.includes(",") && val.includes(".")) {
          return Number(val.replaceAll(".", ""));
        }

        // Normal sayı ya da sadece "," varsa (ondalık)
        if (val.includes(",")) {
          return Number(val.replace(",", "."));
        }

        return Number(val);
      };
    },
  },
  filters: {
    toCurrency(value, currency = "TRY") {
      if (typeof value !== "number") {
        return value;
      }
      const formatter = new Intl.NumberFormat("tr", {
        style: "currency",
        currency,
      });
      return formatter.format(value);
    },
  },
};
